import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";
import { Save2Fill } from "react-bootstrap-icons";
import { Spinner } from "react-bootstrap";

export default function Expenses({ handleSaveExpenses, saving, refetching  }) {
  const {
    expenses,
    setExpenses,
    askMyClient,
    setAskMyClient,
    cashOverUnderEditable,
    setCashOverUnderEditable,
    cashOverUnder,
    setCashOverUnder,
  } = useSalesReceiptStore();
  const initialExpense = { amount: "", amount: 0 };
  const [newExpense, setNewExpense] = useState(initialExpense);
  const [editIndex, setEditIndex] = useState(-1);
  const [totalExpenses, setTotalExpenses] = useState(0);

  useEffect(() => {
    let sum = expenses.reduce((acc, item) => acc + item.expenses_amount, 0);
    sum += parseFloat(askMyClient?.amount) || 0;
    sum += parseFloat(cashOverUnderEditable?.amount) || 0;
    sum += parseFloat(cashOverUnder?.amount) || 0;
    setTotalExpenses(sum);
  }, [expenses, askMyClient, cashOverUnderEditable]);

  const handleExpenseChange = (e, index) => {
    const updatedExpenses = [...expenses];
    updatedExpenses[index].liability = e.target.value;
    setExpenses(updatedExpenses);
  };

  const handleAmountChange = (e, index) => {
    const updatedExpenses = [...expenses];
    updatedExpenses[index].amount = parseFloat(e.target.value);
    setExpenses(updatedExpenses);
  };

  const handleAddExpense = () => {
    if (editIndex === -1) {
      setExpenses([...expenses, newExpense]);
    } else {
      const updatedExpenses = [...expenses];
      updatedExpenses[editIndex] = newExpense;
      setExpenses(updatedExpenses);
      setEditIndex(-1);
    }
    setNewExpense(initialExpense);
  };

  const handleDeleteExpense = (index) => {
    const updatedExpenses = [...expenses];
    updatedExpenses.splice(index, 1);
    setExpenses(updatedExpenses);
  };

  // if (expenses.length === 0) {
  //   return null
  // }
  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <div className="d-flex justify-content-between">
        <h4>Expenses</h4>
        {!saving && !refetching ? (
        <Save2Fill
          fill="gray"
          width="25"
          height="25"
          style={{ cursor: "pointer" }}
          className="mx-2"
          onClick={() => handleSaveExpenses()}
        />
      ) : (
        
          <Spinner animation="border" className="mx-2" size="sm" />
      
      )}
      </div>

      <div className="my-2">
        {expenses.map((item, index) => (
          <div key={index} className="d-flex mb-3">
            <label className="mx-1 w-100 form-control">
              {item.expenses_name}
            </label>
            <input
              type="number"
              className="form-control"
              name="amount"
              value={item.expenses_amount}
              onChange={(e) => handleAmountChange(e, index)}
              readOnly
            />
          </div>
        ))}
        <div className="d-flex mb-3 expense-row">
          <label style={{ height: "100%" }} className="mx-1 form-control">
            Ask my Client
          </label>
          <input
            type="number"
            className="form-control mx-1"
            name="amount"
            style={{ height: "100%" }}
            value={askMyClient?.amount}
            onInput={(e) => {
              const inputValue = e.target.value;
              const parsedValue = parseFloat(inputValue);
              setAskMyClient({
                ...askMyClient,
                amount: isNaN(parsedValue) ? "" : parsedValue,
              });
            }}
          />
          <textarea
            type="text"
            placeholder="Enter Memo"
            style={{ height: "100px" }}
            className="form-control mx-1"
            value={askMyClient?.memo}
            onChange={(e) => {
              setAskMyClient({ ...askMyClient, memo: e.target.value });
            }}
          ></textarea>
        </div>
        <div className="d-flex mb-3 expense-row">
          <label style={{ height: "100%" }} className="mx-1 w-100 form-control">
            Cash Over Under
          </label>
          <input
            type="number"
            className="form-control"
            style={{ height: "100%" }}
            name="amount"
            value={cashOverUnderEditable?.amount}
            onInput={(e) => {
              const inputValue = e.target.value;
              const parsedValue = parseFloat(inputValue);
              setCashOverUnderEditable({
                ...cashOverUnderEditable,
                amount: isNaN(parsedValue) ? "" : parsedValue,
              });
            }}
          />
          <textarea
            type="text"
            placeholder="Enter Memo"
            style={{ height: "100px" }}
            className="form-control mx-1"
            value={cashOverUnderEditable?.memo}
            onChange={(e) => {
              setCashOverUnderEditable({
                ...cashOverUnderEditable,
                memo: e.target.value,
              });
            }}
          ></textarea>
        </div>
        <div className="d-flex mb-3 expense-row">
          <label style={{ height: "100%" }} className="mx-1 w-100 form-control">
            Cash Over Under
          </label>
          <input
            type="number"
            style={{ height: "100%" }}
            className="form-control"
            name="amount"
            value={cashOverUnder?.amount}
            readOnly
            disabled
          />
          <textarea
            type="text"
            placeholder="Memo"
            style={{ height: "100px" }}
            className="form-control mx-1"
            value={cashOverUnder?.memo}
            readOnly
            disabled
          ></textarea>
        </div>
      </div>
      <hr className="featurette-divider" />
      <div className="row d-flex justify-content-end align-items-center mt-3">
        <div className="col-md-6 d-flex">
          <h5 className="text-muted">Total Expense:</h5>
          <p className="fw-bold fs-5">${totalExpenses.toFixed(2)}</p>
        </div>
      </div>
      <hr className="featurette-divider" />
    </div>
  );
}
